export const preparePictureSrcSets = (images, customBreakpoints) => {
    if(images === null || typeof(images) === 'undefined') {
        return false;
    }
    const breakpoints = customBreakpoints ?? {
        jpeg: {
            sm: 640,
            md: 768,
            '2xl': 1386,
            '3xl': 1686,
        },
        webp: {
            sm: 640,
            md: 768,
            '2xl': 1386,
            '3xl': 1686,
        },
    };

    /*
    const sortedBreakpoints = Object.fromEntries(
        Object.entries(breakpoints).sort(([, a], [, b]) => a - b)
    );
     */

    let srcSetString = [];


    for (const imageType in breakpoints) {
        srcSetString.push(
            {
                media: `(max-width: ${breakpoints[imageType].sm - 1}px)`,
                srcset: images[imageType].mp || images[imageType].sm,
                type: `image/${imageType}`,
            });
        srcSetString.push(
            ...Object.entries(breakpoints[imageType]).flatMap(([size, width], index, arr) => {
                return {
                    media: `(min-width: ${width}px)`, // Simplified media query
                    srcset: images[imageType][size] || images[imageType]['sm'],
                    type: `image/${imageType}`, // Dynamically set the type
                };
            })
        );
    }

/*
    srcSetString.sort((a, b) => {
        return a.type === 'image/webp' ? -1 : 1;
        if (a.media !== b.media) {
            // Compare by media query to ensure descending order
            const aWidth = parseInt(a.media.match(/\d+/)[0], 10);
            const bWidth = parseInt(b.media.match(/\d+/)[0], 10);
            return bWidth - aWidth; // Sort descending by width
        } else {
            // If media queries are the same, prioritize webp over jpeg
            return a.type === 'image/webp' ? -1 : 1;
        }
    });

    return srcSetString;
*/
/*
    srcSetString.push(...Object.entries(breakpoints).flatMap(([size, width], index, arr) => {

        return [
            {
                media: `(min-width: ${width}px)`,
                srcset: images[size] || images['sm'],
                type: size.endsWith('webp') ? 'image/webp' : 'image/jpeg',
            },
        ];
    }));
*/
    return srcSetString.reverse();
};
